import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/[id]/page.tsx");
